import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{
    hasLog: boolean;
    hasNetwork: boolean;
  }>()
  .create(({ theme, hasLog, hasNetwork }) => ({
    actionsContainer: {
      display: 'flex',
      alignItems: 'center'
    },
    dashboardUsagePage: {
      display: 'grid',
      gridTemplateColumns:
        hasLog && hasNetwork
          ? 'repeat(3, minmax(0, 1fr))'
          : 'repeat(1, minmax(0, 1fr))',
      gridTemplateRows: 'repeat(2, minmax(8rem, 1fr))',
      gap: '1.5rem',
      height: '100%',
      [theme.breakpoints.down('lg')]: {
        gridTemplateColumns: 'repeat(1, minmax(0, 1fr))',
        gridTemplateRows:
          hasLog && hasNetwork
            ? 'repeat(4, minmax(auto, 300px))'
            : 'repeat(2, minmax(auto, 50%))'
      }
    },
    dashboardThirdWidthItem: {
      height: '100%',
      width: '100%',
      gridRow: 'span 1',
      gridColumn: 'span 1',
      [theme.breakpoints.down('lg')]: {
        minHeight: '18rem'
      }
    },
    dashboardUsageBarGraph: {
      height: '100%',
      width: '100%',
      gridRow: 'span 1',
      gridColumn: hasLog && hasNetwork ? 'span 2' : 'span 1',
      [theme.breakpoints.down('lg')]: {
        gridColumn: 'span 1',
        minHeight: '18rem'
      }
    }
  }));

export default useStyles;
